import axios from 'axios'

import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const { endpoints: { plugins: { ecommerce: URL } } } = config

const getShopInfo = () =>
  axios({
    method: 'get',
    url: `${URL}/shop`,
    headers: getHeaders(true),
  })

const getShopifyURL = (params) =>
  axios({
    method: 'get',
    url: `${URL}/oauth/shopify/url`,
    headers: getHeaders(true),
    params
  })

const pluginEcommerceActivation = ({ shopType, companyType, credential, data }) =>
  axios({
    method: 'post',
    url: `${URL}/shop/plugin-activation`,
    headers: getHeaders(true),
    data: {
      shopType,
      data,
      credential
    }
  })

const downloadCatalog = () =>
  axios({
    method: 'post',
    url: `${URL}/shop/download-catalog`,
    headers: getHeaders(true)
  })

const closeShop = (credentialId) =>
  axios({
    method: 'post',
    url: `${URL}/shop/close`,
    headers: getHeaders(true),
    data: { credentialId }
  })

export default {
  getShopInfo,
  getShopifyURL,
  pluginEcommerceActivation,
  downloadCatalog,
  closeShop
}